export default __webpack_public_path__ + "static/media/gallery_02.eb8c6436.jpg";